import React, { useEffect, useState } from 'react'
import { HeaderOnlyLayout } from '../../layouts'
import { Icon } from '@fluentui/react/lib/Icon'
import {
  KhubMap,
  MobileFilter,
  MobileFilterButtons,
  MobileFilterPanel,
  Button,
  FilterForm,
} from '../../components'
import qs from 'query-string'

// When integrate with backend, get this data from database
import organizationDataNoHover from '../../components/khub-map/data/organization-dummy-data-no-hover'
// import organizationDataWithZoom from '../../components/khub-map/data/organization-dummy-data-with-zoom'
import { useDispatch, useSelector } from 'react-redux';
import MapHeader from './components/map-header';
import { fetchOrganizations } from '../../features/organizations/slice'
import QueryProvider from '../../features/search/hooks/provider'
import { Link, useLocation, useHistory } from 'react-router-dom'
import AudienceListener from '../../features/collection/components/audience-listener'
import colors from '../../utils/colors'
import { useInternationalization } from '../../features/i18n'
import { useViewport } from '../../utils'
import { SystemProvider } from '../../features/system/provider'
import { MobileFilterButton } from '../../components/MobileFilter/MobileFilterButton.v1'
import { Labels } from '../../components/dashboard-listing/list-filter-labels'
import { setQueryString, emptyAllSelectedCollections } from '../../features/search/slice'

const Filter = () => <Icon iconName="Filter" className="ms-Filter text-xl" />;

const resultLabel = {
  en: 'results of the organization location',
  id: 'hasil lokasi organisasi'
}

const OrganizationMap = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const query = qs.parse(location.search)
  const [lastQueryString, setLastQueryString] = useState(null)
  const [mapData, setMapData] = useState([])
  const { isOfficial, isVerified } = useSelector(state => state.account)
  const language = useSelector(state => state.system.language)
  const { translate } = useInternationalization()
  const organizationDataWithZoom = useSelector(state => state.organizations.data_map_nested)
  const [showMap, setShowMap] = useState(false)
  const { isDesktop } = useViewport()

  const _totals = organizationDataWithZoom.map(o => o.total)
  const totalResults = _totals.length > 0 ? _totals.reduce((a, b) => a + b) : 0

  useEffect(() => {
    if(location.search !== lastQueryString){
      setLastQueryString(location.search)
      dispatch(fetchOrganizations(query))
    }
    // eslint-disable-next-line
  }, [dispatch, query])

  useEffect(() => {
    // Verified and official user can access the organization map page
    if (isOfficial || isVerified) {
      setMapData(organizationDataWithZoom)
    } else {
      setMapData(organizationDataNoHover)
    }

    setTimeout(() => {
      setShowMap(true)
    }, 300)
  }, [isOfficial, isVerified, organizationDataWithZoom])

  const handleClear = () => {
    dispatch(setQueryString(''))
    dispatch(emptyAllSelectedCollections())

    history.push(location.pathname)
  }

  return (
    <HeaderOnlyLayout>
      <AudienceListener />
      <QueryProvider>
        <MapHeader />
      </QueryProvider>

      {
        showMap &&
        <KhubMap
          data={mapData}
          additionalOptions={{
            panControl: true,
            gestureHandling: 'cooperative'
          }}
        >
          <div
            style={{
              background: isDesktop ? `linear-gradient(180deg, rgba(34,34,34,1) 0%, rgba(255,255,255,0) 100%)` : `rgba(0, 0, 0, 0.75)`,
            }}
            className="mb-4 lg:mb-0"
          >
            <div className="container mx-auto">
              <div className="flex items-center justify-between text-xs text-white py-5">
                <div className="flex items-center">
                  <p>
                    <span style={{marginRight: '5px', width: '10px', height: '10px', backgroundColor: colors.green, display: 'inline-block', borderRadius: '50%'}} />
                    <span className="opacity-75">{totalResults} {resultLabel[language.name]}</span>
                  </p>
                </div>
                <Link to="/program-map" className="pointer-events-auto">
                  {
                    isDesktop ? (
                      <Button thin className="text-xs">
                        {translate('RELATED', 'view_program_map')}
                      </Button>
                    ) : (
                      <span className="opacity-75 underline">{translate('RELATED', 'view_program_map')}</span>
                    )
                  }
                </Link>
              </div>
            </div>
          </div>
        </KhubMap>
      }

      { /* Mobile Filter Button & Panel */ }
      <div className="lg:hidden">
        <MobileFilter>
          <MobileFilterButtons>
            <MobileFilterButton
              query={query}
              filterKey="filters"
            >
              <div className="mr-2">
                <Filter />
              </div>
              <div>Filter</div>
            </MobileFilterButton>
          </MobileFilterButtons>

          <MobileFilterPanel title="Filters" filterKey="filters">
            <div className="pb-48">
              <SystemProvider>
                <FilterForm
                  id="floating-filter-form"
                  query={query}
                />
                <hr className="my-8"/>
                <Labels query={query} wrap/>
                <p className="text-sm text-gray-444 underline mt-4" onClick={handleClear}>
                  {translate('SEARCH', 'clear')}
                </p>
              </SystemProvider>
            </div>
          </MobileFilterPanel>
        </MobileFilter>
      </div>
    </HeaderOnlyLayout>
  )
}

export { OrganizationMap }
